export const OPEN_CRYPTA_SOCIAL_DEMO_EDITOR = 'OPEN_CRYPTA_SOCIAL_DEMO_EDITOR';
export type OPEN_CRYPTA_SOCIAL_DEMO_EDITOR = typeof OPEN_CRYPTA_SOCIAL_DEMO_EDITOR;

export interface OpenCryptaSocialDemoEditor {
    type: OPEN_CRYPTA_SOCIAL_DEMO_EDITOR;
    id: string;
    itemsId: string[];
}

export function openCryptaSocialDemoEditor(id: string, itemsId: string[]): OpenCryptaSocialDemoEditor {
    return {
        type: OPEN_CRYPTA_SOCIAL_DEMO_EDITOR,
        id,
        itemsId
    };
}

export const CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR = 'CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR';
export type CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR = typeof CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR;

export interface CloseCryptaSocialDemoEditor {
    type: CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR;
    id: string;
}

export function closeCryptaSocialDemoEditor(id: string): CloseCryptaSocialDemoEditor {
    return {
        type: CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR,
        id
    };
}

export const RESET_CRYPTA_SOCIAL_DEMO_EDITOR = 'RESET_CRYPTA_SOCIAL_DEMO_EDITOR';
export type RESET_CRYPTA_SOCIAL_DEMO_EDITOR = typeof RESET_CRYPTA_SOCIAL_DEMO_EDITOR;

export interface ResetCryptaSocialDemoEditor {
    type: RESET_CRYPTA_SOCIAL_DEMO_EDITOR;
    id: string;
}

export function resetCryptaSocialDemoEditor(id: string): ResetCryptaSocialDemoEditor {
    return {
        type: RESET_CRYPTA_SOCIAL_DEMO_EDITOR,
        id
    };
}

export const CHANGE_ITEM_CRYPTA_SOCIAL_DEMO = 'CHANGE_ITEM_CRYPTA_SOCIAL_DEMO';
export type CHANGE_ITEM_CRYPTA_SOCIAL_DEMO = typeof CHANGE_ITEM_CRYPTA_SOCIAL_DEMO;

export interface ChangeItemCryptaSocialDemo {
    type: CHANGE_ITEM_CRYPTA_SOCIAL_DEMO;
    id: string;
    itemId: string;
}

export function changeItemCryptaSocialDemo(id: string, itemId: string): ChangeItemCryptaSocialDemo {
    return {
        type: CHANGE_ITEM_CRYPTA_SOCIAL_DEMO,
        id,
        itemId
    };
}

export type CryptaSocialDemoEditorAction =
    | OpenCryptaSocialDemoEditor
    | CloseCryptaSocialDemoEditor
    | ChangeItemCryptaSocialDemo
    | ResetCryptaSocialDemoEditor;
